<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      intro="U kan een gedichtje kiezen of zich laten inspireren."
      title="Rouwdrukwerk"
    />

    <!-- Sections -->
    <v-row
      v-for="section in sections"
      justify="center"
      :key="section.key"
    >
      <v-col
        class="center mb-8"
        cols="12"
        md="8"
        lg="7"
      >
        <!-- Section title -->
        <div class="rouw-section-header">
          <div class="rouw-section-number">
            {{ section.step }}
          </div>
          <h2 class="rouw-section-title">
            {{ section.title }}
          </h2>
        </div>

        <!-- Text cards -->
        <v-row>
          <v-col
            v-for="(item, index) in PageList(section.key)"
            :key="index"
            cols="12"
            sm="6"
          >
            <div
              class="rouw-card"
              :class="{ 'rouw-card--selected': IsSelected(section, item) }"
            >
              <div class="rouw-card-number">
                {{ item.volgnummer }}
              </div>
              <p class="rouw-card-text">
                {{ item.tekst }}
              </p>
              <span
                v-if="item.auteur"
                class="rouw-card-author"
              >
                &mdash; {{ item.auteur }}
              </span>
              <v-btn
                class="rouw-card-btn mt-4"
                :color="IsSelected(section, item) ? '#6B8E6F' : 'primary'"
                :disabled="IsSelected(section, item)"
                rounded
                @click="section.onSelect(item)"
              >
                <v-icon
                  v-if="IsSelected(section, item)"
                  class="mr-1"
                  size="18"
                >
                  mdi-check
                </v-icon>
                {{ IsSelected(section, item) ? 'Geselecteerd' : 'Kies' }}
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <!-- Pagination -->
        <v-row
          v-if="PageCount(section.key) > 1"
          justify="center"
        >
          <v-col
            class="my-4"
            cols="12"
            lg="8"
          >
            <v-pagination
              v-model="filters[section.key].page"
              color="primary"
              :length="PageCount(section.key)"
            />
          </v-col>
        </v-row>

        <!-- Remark -->
        <div class="rouw-remark">
          <v-textarea
            v-model="data[section.remarkField]"
            auto-grow
            base-color="primary"
            bg-color="white"
            color="primary"
            density="compact"
            label="Opmerking"
            variant="outlined"
          />
          <div class="d-flex justify-end">
            <v-btn
              color="primary"
              rounded
              @click="section.onSelect(data)"
            >
              <v-icon
                class="mr-1"
                size="18"
              >
                mdi-content-save-outline
              </v-icon>
              Opslaan
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import errorMixin from '@/mixins/errorMixin'
import PageHero from '@/components/PageHero.vue'
import klantService from '@/services/klantService'

export default {
  name: 'RouwdrukwerkComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    errorMixin,
  ],
  data () {
    return {
      data: {
        hoofdingen: [],
        teksten: []
      },
      filters: {
        hoofdingen: {
          numberPerPage: 4,
          page: 1
        },
        teksten: {
          numberPerPage: 4,
          page: 1
        }
      }
    }
  },
  computed: {
    sections () {
      return [
        {
          step: '1',
          title: 'Hoofding rouwbrief',
          key: 'hoofdingen',
          idField: 'idRouwbriefhoofding',
          remarkField: 'rouwbriefhoofdingOpmerking',
          onSelect: (item) => this.SelecteerHoofding(item)
        },
        {
          step: '2',
          title: 'Tekst prentje',
          key: 'teksten',
          idField: 'idPrentjeTekst',
          remarkField: 'prentjeTekstOpmerking',
          onSelect: (item) => this.SelecteerPrentjeTekst(item)
        }
      ]
    }
  },
  async mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    klantService.Init(this)
    this.$store.state.headers.keuzesUitvaart = true
    await this.GetRouwbriefhoofdingList(true)
    await this.GetPrentjeTekstList(true)
  },
  beforeUnmount () {
    this.$store.state.headers.keuzesUitvaart = false
  },
  methods: {
    async GetPrentjeTekstList (setPage) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartPrentjeTekstList()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = {
          ...this.data,
          ...this.CommonMixin_Clone(resp.data)
        }

        if (setPage) {
          const itemIndex = this.data.teksten.findIndex(item =>
            item.idPrentjeTekst === this.data.idPrentjeTekst
          )

          if (itemIndex !== -1) {
            const pageNumber = Math.ceil((itemIndex + 1) / this.filters.teksten.numberPerPage);
            this.filters.teksten.page = pageNumber;
          } else {
            this.filters.teksten.page = 1
          }
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetRouwbriefhoofdingList (setPage) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartRouwbriefhoofdingList()

      if (resp && (resp.data || resp.data !== '')) {
        this.data = {
          ...this.data,
          ...this.CommonMixin_Clone(resp.data)
        }

        if (setPage) {
          const itemIndex = this.data.hoofdingen.findIndex(item =>
            item.idRouwbriefhoofding === this.data.idRouwbriefhoofding
          )

          if (itemIndex !== -1) {
            const pageNumber = Math.ceil((itemIndex + 1) / this.filters.hoofdingen.numberPerPage);
            this.filters.hoofdingen.page = pageNumber;
          } else {
            this.filters.hoofdingen.page = 1
          }
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    PageList (subtype) {
      return this.CommonMixin_GetPageList(this.data[subtype], this.filters[subtype].page, this.filters[subtype].numberPerPage)
    },
    PageCount (subtype) {
      return this.CommonMixin_GetPageCount(this.data[subtype], this.filters[subtype].numberPerPage)
    },
    async SelecteerHoofding (rouwbriefhoofding) {
      this.CommonMixin_Load(this.$options.name, true)
      this.data.idRouwbriefhoofding = rouwbriefhoofding.idRouwbriefhoofding
      await klantService.SaveUitvaartRouwbriefhoofding(this.data)
      await this.GetRouwbriefhoofdingList()
      this.CommonMixin_Load(this.$options.name, false)
    },
    IsSelected (section, item) {
      return item[section.idField] === this.data[section.idField]
    },
    async SelecteerPrentjeTekst (prentjeTekst) {
      this.CommonMixin_Load(this.$options.name, true)
      this.data.idPrentjeTekst = prentjeTekst.idPrentjeTekst
      await klantService.SaveUitvaartPrentjeTekst(this.data)
      await this.GetPrentjeTekstList()
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
/* Section header */
.rouw-section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.rouw-section-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #907322;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.rouw-section-title {
  font-size: 22px;
  font-weight: 500;
  color: #424E58;
  padding: 0;
  margin: 0;
}

/* Text cards */
.rouw-card {
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  padding: 20px;
  background-color: #fdfcfa;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: border-color 0.2s ease;
}

.rouw-card--selected {
  border-color: #6B8E6F;
  background-color: #f5faf5;
}

.rouw-card-number {
  width: 28px;
  height: 28px;
  border: 2px solid #907322;
  border-radius: 15%;
  color: #907322;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.rouw-card-text {
  font-size: 15px;
  line-height: 1.7;
  color: #424E58;
  white-space: pre-line;
  flex: 1;
}

.rouw-card-author {
  font-size: 14px;
  font-style: italic;
  color: #999;
  margin-bottom: 4px;
}

.rouw-card-btn {
  text-transform: none;
  letter-spacing: 0;
  width: 100%;
}

/* Remark section */
.rouw-remark {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e8e4dc;
}
</style>
